import axios from 'axios';

const api = axios.create({
// baseURL: "http://192.168.29.201:5000"
// baseURL: "https://admin.roamjssln.com"

 baseURL: "https://development.roamjssln.com"
});

export default api;